import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    PDFViewer,
    Image,
} from "@react-pdf/renderer";

import signature from "../assets/images/kishoresig.jpeg";
import rupeeImg from "../assets/images/rupee.png";
var converter = require('number-to-words');

const RupeeImage = () => {
    return (
        <Image
            style={styles.rupeeImage}
            src={rupeeImg} // Replace with your image URL or local path
        />
    )
}

export const InvoiceDocument = ({indTrascDetails = {}}) => {
    return(
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Header Section */}
                <View style={styles.header}>
                    <Text style={styles.TaxInvoiceText}>Tax Invoice</Text>
                </View>
                <View style={styles.subHeading}>
                    <Text>Invoice Details</Text>
                </View>
                <View style={styles.detailsTable}>
                    <View style={styles.section}>
                        <View style={styles.sectionLeftView}><Text style={{}}>Invoice No: {indTrascDetails.orderId}</Text></View>
                        <View style={styles.sectionRightView}><Text>Invoice Date: {indTrascDetails.date}</Text></View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.sectionLeftView}><Text style={{}}>Invoice From: BUYANDWIN</Text></View>
                        <View style={styles.sectionRightView}><Text>Invoice To: {indTrascDetails.name}</Text></View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.sectionLeftView}><Text style={{}}>Address: {"\n"}
                            GROUND FLOOR, H.NO.49-416/8/H/1, PLOTNO.580-H,PADMANAGAR PHASE-2,CHINTAL,HYDERABAD,TELANGANA,PINCODE :500054
                        </Text></View>
                        <View style={styles.sectionRightView}><Text>Contact No: {indTrascDetails.mobileNo}</Text></View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.sectionLeftView}><Text style={{}}>State: Telangana</Text></View>
                        <View style={styles.sectionRightView}><Text>Country: India</Text></View>
                    </View>
                    <View style={[styles.section, { borderBottomWidth: 0 }]}>
                        <View style={styles.sectionLeftView}><Text style={{}}>Gst No: 36ACHPY6931H2Z2 </Text></View>
                        <View style={styles.sectionRightView}><Text>Gst: No</Text></View>
                    </View>
                </View>
                <View style={styles.subHeading}>
                    <Text>Product Details</Text>
                </View>
                {/* Product Table */}
                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={[styles.tableRow, styles.tableHeader]}>
                        <Text style={styles.tableCell}>Sl. No</Text>
                        <Text style={styles.tableCell}>Description</Text>
                        <Text style={styles.tableCell}>Qty</Text>
                        <Text style={styles.tableCell}>Net Amount</Text>
                        <Text style={styles.tableCell}>Tax Rate</Text>
                        <Text style={styles.tableCell}>Tax Type</Text>
                        <Text style={styles.tableCell}>Tax Amount</Text>
                        <Text style={[styles.tableCell, styles.lastCell]}>Total</Text>
                    </View>
                    {/* Table Row 1 */}
                    <View style={styles.tableRow}>
                        <Text style={styles.tableCell}>1</Text>
                        <Text style={styles.tableCell}>Digital Image Download</Text>
                        <Text style={styles.tableCell}>{indTrascDetails.quantity}</Text>
                        <Text style={styles.tableCell}> <RupeeImage />{indTrascDetails.tokenPrice}</Text>
                        <Text style={styles.tableCell}>18%</Text>
                        <Text style={styles.tableCell}>Igst</Text>

                        <Text style={styles.tableCell}><RupeeImage />{indTrascDetails.gstAmount}</Text>
                        <Text style={[styles.tableCell, styles.lastCell]}><RupeeImage />{indTrascDetails.totAmt}</Text>
                    </View>
                    <View style={[styles.section, { borderBottomWidth: 0 }]}>
                        <View style={styles.sectionRightView}><Text>Amount in Words:{" "} 
                            <Text style={{textTransform:"capitalize"}}>{converter.toWords(Number(indTrascDetails.totAmt) || 0)}</Text>
                            {" "}Rupees Only</Text></View>
                    </View>
                </View>
                <Text style={styles.productTitle}>BUYANDWIN</Text>
                <View style={styles.sigImagecontainer}>
                    <Image
                        style={styles.sigImage}
                        src={signature} // Replace with your image URL or local path
                    />
                </View>
                <Text style={styles.productTitle}>AUTHORIZED SIGNATORY</Text>
                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={[styles.tableRow, { borderBottomWidth: 0 }]}>
                        <Text style={styles.tableCell}>Payment Transaction ID : {"\n"}
                            <Text style={{ fontWeight: "bold" }}>{indTrascDetails.transacId}</Text></Text>
                        <Text style={styles.tableCell}>Date : {"\n"}
                            <Text style={{ fontWeight: "bold" }}>{indTrascDetails.date}</Text></Text>
                        <Text style={styles.tableCell}>Invoice Value : {"\n"}
                            <Text style={{ fontWeight: "bold" }}><RupeeImage />{indTrascDetails.totAmt}</Text></Text>
                        <Text style={styles.tableCell}>Mode Of Payment : {"\n"}
                            <Text style={{ fontWeight: "bold" }}>UPI</Text></Text>
                    </View>
                </View>
                <View style={{ marginTop: 10 }}>
                    <Text>Contact for queries : <Text style={{ fontWeight: "500" }}>support@buyandwin.in</Text></Text>
                    <Text>* Terms and conditions apply</Text>
                </View>
            </Page>
        </Document>
)};

const TaxInvoicePDF = ({ indTrascDetails }) => (
    <PDFViewer width="100%" height="600px">
        <InvoiceDocument indTrascDetails={indTrascDetails} />
    </PDFViewer>
);
export default TaxInvoicePDF;

// Define styles
const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 10
    },
    header: {
        marginBottom: 20,
        fontSize: 12
    },
    TaxInvoiceText: {
        textAlign: "center",
        textDecoration: "underline",
        fontWeight: "bold",

    },
    subHeading: {
        textDecoration: "underline",
        fontWeight: "700",
        textTransform: "uppercase"
    },
    detailsTable: {
        borderWidth: 1,
        borderColor: "black",
        marginBottom: 20,
        marginTop: 10
    },
    section: {
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "row",
        flexWrap: "nowrap",
        borderBottomColor: "black",
        borderBottomWidth: 1
    },
    sectionLeftView: {
        borderRightWidth: 1,
        borderRightColor: "black",
        paddingHorizontal: 10,
        paddingVertical: 2,
        width: "50%"
    },
    sectionRightView: {
        paddingHorizontal: 10,
        paddingVertical: 2,
        width: "50%"
    },
    table: {
        display: "table",
        width: "100%",
        borderWidth: 1,
        borderColor: "#000",
        borderStyle: "solid",
        marginVertical: 10
    },
    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1
    },
    tableCell: {
        flex: 1,
        padding: 2,
        borderRightWidth: 1,
        borderColor: "#000",
        borderStyle: "solid",
        textAlign: "center",
    },
    tableHeader: {
        fontWeight: "bold",
        backgroundColor: "#e0e0e0",
    },
    bold: {
        fontWeight: "bold",
    },
    lastCell: {
        borderRightWidth: 0
    },
    productTitle: {
        textAlign: "right",
        fontWeight: "bold",
    },
    sigImage: {
        width: 40,
        height: 20,
        marginRight: 10
    },
    rupeeImage: {
        width: 7,
        height: 7,
    },
    sigImagecontainer: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end"
    }
});
